export enum SettingTypeEnum {
  'user' = 'user',
  'userproject' = 'userproject',
  'project' = 'project',
  'global' = 'global'
}
